  /**
   * Returns number of rows and columns as a tuple [number of rows, number of columns].
   * Used for preventing deleting multiple rows/cols when all are selected.
   */
  export const getRowColCount = (element) => {
    if (!element) return [0, 0];
    const rowCount = element.children?.length ? element.children.length : 0;
    if (rowCount === 0) return [0, 0];
    const colCount = element.children.reduce((acc, child) => {
      if (child.children?.length) {
        if (child.children.length > acc) return child.children.length;
        return acc;
      }
      return acc;
    }, 0);
    return [rowCount, colCount];
  };
